var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 15,
    fill: "#2E77D0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3789 14.5C10.3789 11.6716 10.3789 10.2574 11.2576 9.37868C12.1363 8.5 13.5505 8.5 16.3789 8.5H17.5039C20.3323 8.5 21.7466 8.5 22.6252 9.37868C23.5039 10.2574 23.5039 11.6716 23.5039 14.5V17.5C23.5039 20.3284 23.5039 21.7427 22.6252 22.6213C21.7466 23.5 20.3323 23.5 17.5039 23.5H16.3789C13.5505 23.5 12.1363 23.5 11.2576 22.6213C10.3789 21.7427 10.3789 20.3284 10.3789 17.5V14.5Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3789 11.5H8.50391M10.3789 16H8.50391M10.3789 20.5H8.50391",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4608 13.3691C18.4608 14.1975 17.7892 14.8691 16.9609 14.8691C16.1325 14.8691 15.4609 14.1975 15.4609 13.3691C15.4609 12.5407 16.1325 11.8691 16.9609 11.8691C17.7892 11.8691 18.4608 12.5407 18.4608 13.3691Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9925 18.7864C14.7863 17.5645 16.0469 17.1065 16.9589 17.1074C17.8709 17.1084 19.0945 17.5645 19.8882 18.7864C19.9396 18.8655 19.9537 18.9628 19.9074 19.0449C19.7218 19.3741 19.1454 20.0272 18.7291 20.0716C18.2508 20.1224 16.9995 20.1295 16.9598 20.1298C16.9201 20.1295 15.6302 20.1224 15.1517 20.0716C14.7354 20.0272 14.159 19.3741 13.9734 19.0449C13.9271 18.9628 13.9412 18.8655 13.9925 18.7864Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclation);
export default __webpack_public_path__ + "static/media/exclation.6f793c1de3f076983384700a5c565ae8.svg";
export { ForwardRef as ReactComponent };